<script setup>
// import SpinnerHtml from "../components/SpinnerHtml.vue"
</script>
<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="d-flex align-items-center p-3 my-3 text-dark-50 bg-lightblue rounded shadow-sm">
          <div class="lh-100">
            <h6 class="border-bottom border-gray pb-2 mb-0 lh-100"><b>Orders</b></h6>
          </div>
        </div>
        <!--                <div class="table-responsive">-->
        <!--                    <table class="table">-->
        <!--                        <thead class="text-bold">-->
        <!--                        <tr>-->
        <!--                            <th scope="col">#</th>-->
        <!--                            <th scope="col">PHONE NUMBER</th>-->
        <!--                            <th scope="col">REASON</th>-->
        <!--                            <th scope="col">CBY</th>-->
        <!--                            <th scope="col">DATETIME</th>-->
        <!--                            <th scope="col">ACTION</th>-->
        <!--                        </tr>-->
        <!--                        </thead>-->
        <!--                        <tbody>-->
        <!--                        <tr v-for="(row, index) in tables" :key="row.id">-->
        <!--                            <td scope="row">{{ index + 1 }}</td>-->
        <!--                            <td>{{ row.phonenumber }}</td>-->
        <!--                            <td>{{ row.reason }}</td>-->
        <!--                            <td>{{ row.cby }}</td>-->
        <!--                            <td>{{ format_date(row.timestamp) }}</td>-->
        <!--                            <td>-->
        <!--                                <button type="button" @click="integrationAction(index, 'edit')" class="btn btn-success"-->
        <!--                                        data-toggle="modal"-->
        <!--                                        data-target="#exampleModal">Edit-->
        <!--                                </button>-->
        <!--                                <button type="button" @click="integrationAction(index, 'delete')"-->
        <!--                                        class="btn btn-danger">Delete-->
        <!--                                </button>-->
        <!--                            </td>-->
        <!--                        </tr>-->
        <!--                        </tbody>-->
        <!--                    </table>-->
        <!--                </div>-->

        <div class="table-responsive">
          <div style="height: 100%">
            <div class="example-wrapper">
              <div class="example-header">
                <input type="text" class="form-control" id="filter-text-box" maxlength="20" placeholder="Search here..."
                       v-on:input="onFilterTextBoxChanged()">
              </div>
              <ag-grid-vue
                  domLayout="autoHeight"
                  style="width: 100%; height: 100%;"
                  class="ag-theme-alpine"
                  :columnDefs="columnDefs"
                  @grid-ready="onGridReady"
                  :defaultColDef="defaultColDef"
                  :rowData="rowData"
                  :cacheQuickFilter="true"
                  :pagination="true"></ag-grid-vue>
            </div>
          </div>
        </div>

      </div>
    </div>
    <!--    model begin-->
    <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" data-backdrop="static"
         data-keyboard="false"
         aria-labelledby="exampleModalLabel"
         aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel" v-show="form.id === ''">Add new group</h5>
            <h5 class="modal-title" id="exampleModalLabel" v-show="form.id !== ''">Edit group- {{ form.phonenumber }}</h5>
            <button type="button" ref="modalClose" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form @submit="onSubmit">
            <div class="modal-body">
              <div class="form-group">
                <label for="integration-phonenumber" class="col-form-label">Enter group name:<span
                    class="text-danger">*</span></label>
                <input type="text" class="form-control" minlength="5" maxlength="20"
                       v-model="form.phonenumber"
                       id="integration-phonenumber" placeholder="Enter group name" required>
              </div>
              <div class="form-group">
                <label class="col-form-label">Select upload type:<span class="text-danger" v-show="form.id === ''">*</span></label>
                &nbsp;
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="groupType" id="pasteRadio" value="paste"
                         v-model="form.groupType" checked="true" :required="form.id === ''">
                  <label class="form-check-label" for="pasteRadio">Paste</label>
                </div>

                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="groupType" id="uploadRadio" value="upload"
                         v-model="form.groupType" :required="form.id === ''">
                  <label class="form-check-label" for="uploadRadio">Upload</label>
                </div>
              </div>
              <div class="form-group" v-show="form.groupType == 'paste'">
                <label for="integration-token-id" class="col-form-label">Paste number here:<span
                    class="text-danger">*</span></label>
                <textarea class="form-control" id="integration-token-id" rows="2"
                          placeholder="Enter reason here..." minlength="10" maxlength="131" row="5"
                          v-model="form.reason" :required="form.groupType === 'paste'"></textarea>
                <small class="text-danger"> Paste 10 and below numbers with <u><b>comma, spaces, newline</b></u>.,
                  otherwise upload a file., 91 not compulsory</small>
              </div>
              <div class="form-group" v-show="form.groupType == 'upload'">
                <label for="inputPassword3" class="col-form-label">Choose .xlsx file with header <span
                    class="text-danger">*</span></label>
                <input type="file" class="form-control" id="inputPassword3" placeholder="Choose file"
                       accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                       @change="onFileChange" :disabled="validated == 1" :required="form.groupType === 'upload'">
                <small id="emailHelp" class="form-text text-danger">Excel files only accepted with maximum 10 MB. First
                  column only consider., set numbers in first column</small>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
              <button type="submit" class="btn btn-primary">Save</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!--    model end-->
    <!--    list model begin-->
    <div class="modal fade" id="listModal" tabindex="-1" role="dialog" data-backdrop="static"
         data-keyboard="false"
         aria-labelledby="listModalLabel"
         aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="listModalLabel">{{ form.phonenumber }} ({{ exportDivShowHide }} / {{ rowListData.length }})</h5>
            <button type="button" ref="modalListClose" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="example-header">
            <input type="text" class="form-control" id="filter-text-box-list" maxlength="20" placeholder="Search here..."
                   v-on:input="onFilterTextBoxListChanged()">
          </div>
          <ag-grid-vue
              domLayout="autoHeight"
              style="width: 100%; height: 100%;"
              class="ag-theme-alpine"
              :columnDefs="columnListDefs"
              @grid-ready="onGridReadyList"
              :defaultColDef="defaultColDef"
              :rowData="rowListData"
              :cacheQuickFilter="true"
              :pagination="true"
              :paginationPageSize="10"
              @cellValueChanged="onCellValueChanged"></ag-grid-vue>
        </div>
      </div>
    </div>
    <!--    list model end-->
    <button-cell-renderer v-show="false"></button-cell-renderer>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment/moment";
import {AgGridVue} from "ag-grid-vue3";  // the AG Grid Vue Component
// import { reactive, onMounted, ref } from "vue";
// import BtnCellRenderer from './btn-cell-renderer'
import "ag-grid-community/styles/ag-grid.css"; // Core grid CSS, always needed
import "ag-grid-community/styles/ag-theme-alpine.css";
import * as XLSX from "xlsx";
import eventBus from '@/views/eventBus';
import ButtonCellRenderer from '@/views/ButtonCellRenderer'

export default {
  components: {
    'ag-grid-vue': AgGridVue,
    'button-cell-renderer': ButtonCellRenderer,
  },
  data() {
    return {
      form: {
        phonenumber: '',
        groupType: 'paste',
        reason: '',
        id: '',
        fileUpload: null,
      },
      tables: [],
      show: true,
      columnListDefs: [
        {
          headerName: '#',
          valueGetter: "node.rowIndex + 1",
          flex: 0.5
        },
        {
          headerName: 'GROUP',
          field: 'phonenumber',
          flex: 2,
          editable: true
        },
        {
          headerName: 'createdAt',
          field: 'createdAt',
          flex: 2,
          valueFormatter: (params) => {
            if (params.value) {
              return moment(params.value).format('DD-MM-YYYY hh:mm:ss a')
            }
          }
        },
      ],
      columnDefs: [
        {
          headerName: '#',
          valueGetter: "node.rowIndex + 1",
          flex: 0.5
        },
        {
          headerName: 'FROM',
          field: 'from',
          flex: 1.5
        },
        {
          headerName: 'ADDRESS',
          field: 'address',
          flex: 2
        },
        {
          headerName: 'CATALOG',
          field: 'catalog',
          // valueGetter: "0",
          flex: 1.5
        },
        {
          headerName: 'PRODUCTS',
          field: 'product',
          // valueGetter: "0",
          flex: 1
        },
        {
          headerName: 'QTY',
          field: 'quantity',
          // valueGetter: "0",
          flex: 1
        },
        {
          headerName: 'PRICE',
          field: 'price',
          // valueGetter: "0",
          flex: 1
        },
        {
          headerName: 'createdAt',
          field: 'timestamp',
          flex: 2,
          valueFormatter: (params) => {
            if (params.value) {
              return moment(params.value).format('DD-MM-YYYY hh:mm:ss a')
            }
          }
        },
        // {
        //   headerName: 'Action',
        //   field: '_id',
        //   cellRendererFramework: 'button-cell-renderer', // Use your component name
        //   width: 100,
        //   autoHeight: true
        // },
        // {
        //   headerName: 'Action',
        //   cellRenderer: 'button-cell-renderer',
        //   cellStyle: {'white-space': 'normal'},
        //   autoHeight: true,
        //   flex: 2.5,
        //   width: 100,
        // }
      ],
      gridApi: null,
      gridApiList: null,
      columnApi: null,
      defaultColDef: {
        sortable: true,
        flex: 1,
        // editable: true,
      },
      rowData: null,
      rowListData: [],
      validated: 0,
      exportDivShowHide: ''
    }
  },
  async created() {
    var getTemp = await this.getNumberIntegrationList();
    this.tables = getTemp.data.message;
    this.rowData = [];
    this.rowListData = [];
    this.exportDivShowHide = this.rowListData.length;
    this.rowData = this.tables;
  },
  async mounted() {
    eventBus.on('handleEditButtonClick', (eventData) => {
      this.handleEditButtonClick(eventData)
    })
    eventBus.on('handleListButtonClick', (eventData) => {
      this.handleListButtonClick(eventData)
    })
    eventBus.on('handleDeleteButtonClick', (eventData) => {
      this.handleDeleteButtonClick(eventData)
    })
  },
  methods: {
    async onCellValueChanged(event) {  // console.log(event)
      // Handle the data update here
      const { data, newValue, oldValue } = event;
      // Update the value in your database using an API call
      // console.log(`Updated ${colDef.field} for ${oldValue} to ${newValue}, ${data._id}`);
      const trimmedValue = newValue.trim();
      var finalValue = trimmedValue;
      if (isNaN(trimmedValue)) {
        finalValue = "";
      } else if (trimmedValue.length === 10 && /^[6-9]/.test(trimmedValue)) {
        finalValue = '91' + trimmedValue;
      } else if (trimmedValue.length === 12 && trimmedValue.startsWith('91') && /^[6-9]/.test(trimmedValue.charAt(3))) {
        finalValue = trimmedValue;
      } else {
        finalValue = "";
      }
      if (!finalValue) {
        alert("Enter correct phonenumber!");
        // event.node.setDataValue(event.column.colId, event.oldValue);
        this.rowListData[event.rowIndex].phonenumber = oldValue;
        this.gridApiList.refreshCells();
        // return false; // Cancel the update
      } else {
        let getAxiosRequest = await this.axiosRequest('/contactGroup/contacts_list_edit', { id: data._id, newValue: finalValue, group: data.group });

        var responseTitle;
        if (getAxiosRequest.data.status) {
          responseTitle = {title: "Success", icon: "success"};
          this.sweetAlert(responseTitle.icon, responseTitle.title, getAxiosRequest.data.message, 'btn-primary');
          this.rowListData[event.rowIndex].phonenumber = finalValue;
          this.gridApiList.refreshCells();
          // return true;
        } else {
          responseTitle = {title: "Failed", icon: "error"};
          // event.node.setDataValue(event.column.colId, event.oldValue);
          this.rowListData[event.rowIndex].phonenumber = oldValue;
          this.gridApiList.refreshCells();
          this.sweetAlert(responseTitle.icon, responseTitle.title, getAxiosRequest.data.message, 'btn-primary');
          // return false; // Cancel the update
        }
      }
    },
    handleEditButtonClick(eventData) { // index, url, data, dataJson
      // console.log(eventData)
      this.form = {
        phonenumber: eventData.data.name,
        groupType: '',
        id: eventData.id,
        reason: ''
      };
      // console.log(this.form)
    },
    async handleListButtonClick(eventData) { // index, url, data, dataJson
      this.rowListData = [];
      this.form = {
        phonenumber: eventData.data.name,
        groupType: '',
        id: '',
        reason: '',
        fileUpload: null,
      };
      document.getElementById('filter-text-box-list').value = "";
      this.gridApiList.setQuickFilter('');
      const templateURL = '/contactGroup/contacts_list';
      var getTemp = await this.axiosRequest(templateURL, { id: eventData.id});
      this.rowListData = getTemp.data.message;
      this.exportDivShowHide = this.rowListData.length;
    },
    async handleDeleteButtonClick(eventData) { // index, url, data, dataJson
      let getAxiosRequest = await this.axiosRequest('/contactGroup/contact_group_delete', {id: eventData.id});

      var responseTitle;
      if (getAxiosRequest.data.status) {
        responseTitle = {title: "Success", icon: "success"};
      } else {
        responseTitle = {title: "Failed", icon: "error"};
      }
      this.sweetAlert(responseTitle.icon, responseTitle.title, getAxiosRequest.data.message, 'btn-primary');
      var getTemp = await this.getNumberIntegrationList();
      this.tables = getTemp.data.message;
      this.rowData = this.tables;
    },
    async onSubmit(event) {
      event.preventDefault()
      var getDynamicConfirm = (this.form.id) ? 'Are you sure to edit?' : 'Are you sure to save?';
      if (confirm(getDynamicConfirm)) {
        this.begin_loading()
        this.validated = 1
        if (this.form.groupType == 'paste')
          this.form.fileUpload = null
        else if (this.form.groupType == 'upload')
          this.form.reason = ''
        var form = new FormData();
        form.append('phonenumber', this.form.phonenumber);
        form.append('groupType', this.form.groupType);
        form.append('reason', this.form.reason);
        form.append('id', this.form.id);
        form.append('fileUpload', this.form.fileUpload);
        // const config = {
        //   // 'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
        //   // headers: {
        //   //   'Content-Type': 'multipart/form-data'
        //   // }
        // }
        const NMPUSER = JSON.parse(localStorage.getItem('NMPUSER'))
        if (!(localStorage.getItem('NMPUSER') && NMPUSER && Object.prototype.hasOwnProperty.call(NMPUSER, "token") && NMPUSER.token && NMPUSER.token == this.waId && NMPUSER.token != "")) {
          this.$router.push('/');
          return false;
        }
        const config = {
          headers: {
            // 'Content-Type': 'application/json',
            'Content-Type': 'multipart/form-data',
            'x-access-token': NMPUSER.token,
          }
        }
        await axios.post('/contactGroup/contact_group_add',
            // {
            //   phonenumber: this.form.phonenumber,
            //   groupType: this.form.groupType,
            //   reason: this.form.reason
            // }, // the data to post
            form,
            config).then(response => {
          var responseTitle;
          if (response.data.status) {
            responseTitle = {title: "Success", icon: "success"};
          } else {
            responseTitle = {title: "Failed", icon: "error"};
          }
          this.$swal({
            title: responseTitle.title,
            html: response.data.message,
            icon: responseTitle.icon,
            customClass: {
              confirmButton: 'btn btn-primary',
            },
            buttonsStyling: false,
          })
        });
        this.end_loading()
        this.form = {
          phonenumber: '',
          groupType: '',
          id: '',
          reason: '',
          fileUpload: null,
        };
        this.validated = 0
        this.$refs.modalClose.click();
        var getTemp = await this.getNumberIntegrationList();
        this.tables = getTemp.data.message;
        this.rowData = this.tables;
      }
    },
    async onFileChange(event) {
      this.form.fileUpload = event.target.files[0]
      // var files = event.target.files, f = files[0];
      // var MainXlsxHeaders = await this.readRecord(f).then(function (record) {
      //   // const keys = Object.keys(record[0]);
      //   return record;
      // }); // MainXlsxHeaders xlsxHeaders
      // var xlsxHeaders = Object.keys(MainXlsxHeaders[0]);
    },
    readRecord(f) {
      return new Promise(function (resolve) {
        var reader = new FileReader();
        reader.onload = function (e) {
          var bstr = new Uint8Array(e.target.result);
          var workbook = XLSX.read(bstr, {type: 'array'});
          let sheetName = workbook.SheetNames[0]
          /* DO SOMETHING WITH workbook HERE */
          // console.log(workbook);
          let worksheet = workbook.Sheets[sheetName];
          const data = XLSX.utils.sheet_to_json(worksheet);
          resolve(data);
        };
        reader.readAsArrayBuffer(f);
      });
    },
    onReset(event) {
      event.preventDefault()
      // Reset our form values
      this.form.template = ''
      this.form.name = ''
      this.form.food = null
      this.form.checked = []
      // Trick to reset/clear native browser form validation state
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    },
    async getNumberIntegrationList() {
      // // const templateURL = 'https://graph.facebook.com/v16.0/100312339706932/message_templates?limit=3&access_token=EAAUJ4rpATrABAFJfj9AwJGKRzBX4l3VSNmfLZAlCcVChd8qGX8P6yv3djKZC8Kr9NEKhCagzqIbf8vTiuYt2xBPGjUr9prMuhOgYnvz2PDfcX5ioweo4RFwKOj884xG9beG0XmDPH1n1rmYd2zQJGfoHQQehlUj0gHxZCs1oNSZBEFQUos3qtqgOISZAthbLOC7PP1FRIawQmZC2ZCG3lzM7Xg7ZC41BTIsZD';
      const templateURL = '/contactGroup/wa_orders_list';
      return await this.axiosRequest(templateURL, {});
    },
    format_date(value) {
      if (value) {
        return moment(value).format('DD-MM-YYYY hh:mm:ss a');
      } else {
        return "";
      }
    },
    async integrationAction(index, mode) {
      this.form = {
        phonenumber: '',
        id: '',
        groupType: 'paste',
        reason: ''
      };
      if (mode == 'edit') {
        this.form = this.tables[index]
      } else {
        let phonenumber = this.tables[index].phonenumber
        this.$swal({
          title: 'Are you sure?',
          text: 'you going to unblock this number',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, Unblock it!',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then(async result => {
          if (result.isConfirmed) {
            let getAxiosRequest = await this.axiosRequest('/contactGroup/contact_group_delete', {phonenumber: phonenumber});

            var responseTitle;
            if (getAxiosRequest.data.status) {
              responseTitle = {title: "Success", icon: "success"};
            } else {
              responseTitle = {title: "Failed", icon: "error"};
            }
            this.sweetAlert(responseTitle.icon, responseTitle.title, getAxiosRequest.data.message, 'btn-primary');
            var getTemp = await this.getNumberIntegrationList();
            this.tables = getTemp.data.message;
            this.rowData = this.tables;
          }
        })
      }
    },
    openModelClickMethod() {
      this.form = {
        phonenumber: '',
        groupType: 'paste',
        id: '',
        reason: ''
      };
    },
    onFilterTextBoxChanged() {
      this.gridApi.setQuickFilter(
          document.getElementById('filter-text-box').value
      );
    },
    onFilterTextBoxListChanged() {
      this.gridApiList.setQuickFilter(
          document.getElementById('filter-text-box-list').value
      );
      if (this.gridApiList.getDisplayedRowCount())
        this.exportDivShowHide = this.gridApiList.getDisplayedRowCount();
      else
        this.exportDivShowHide = 0;
    },
    onGridReady(params) {
      this.gridApi = params.api;
      // this.gridColumnApi = params.columnApi;
    },
    onGridReadyList(params) {
      this.gridApiList = params.api;
      // this.gridColumnApi = params.columnApi;
    }
  }
}
</script>
<style>
@media (min-width: 1024px) {
  .about {
    min-height: 100vh;
    display: flex;
    align-items: center;
  }
}

.bg-lightblue {
  background-color: lightblue;
}

/*td {*/
/*  white-space: normal !important;*/
/*  word-wrap: break-word;*/
/*}*/
/*table {*/
/*  table-layout: fixed;*/
/*}*/
</style>
